import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';
import './lib/photoswipe.css';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.min.js';
import errorBoundary from '@ifeng-fe/errorBoundary';

let hasGallery = false;

class Pic extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        galleryShow: PropTypes.bool,
        galleryCurrent: PropTypes.number,
        handleGalleryClose: PropTypes.func,
    };

    state = {
        galleryCurrent: this.props.galleryCurrent,
    };

    swiper = React.createRef();

    componentDidUpdate() {
        const { galleryShow, galleryCurrent } = this.props;

        if (galleryShow && !hasGallery) {
            hasGallery = true;

            const element = this.swiper.current;
            const options = {
                index: galleryCurrent,
                bgOpacity: 1,
                spacing: 0.06,
                preload: [1, 3],
                loop: false,
                history: false,
                pinchToClose: false,
                closeOnScroll: false,
                closeOnVerticalDrag: false,
            };
            const items = this.handleImages([...this.props.content]);

            try {
                this.slide = new PhotoSwipe(element, PhotoSwipeUI_Default, items, options);

                this.slide.init();

                this.slide.listen('afterChange', () => {
                    const index = this.slide.getCurrentIndex();

                    this.setState({
                        galleryCurrent: index,
                    });
                });

                this.setState({
                    galleryCurrent,
                });
            } catch (e) {
                console.error(e);

                const id = element.id;
                const classList = element.classList;
                const info = JSON.stringify(element.getBoundingClientRect());

                e.message = `${e.message} | id: ${id} | class: ${classList} | dom: ${info}`;

                if (window && window.BJ_REPORT) window.BJ_REPORT.report(e, false, 'photoswipe');
            }
        }

        if (!galleryShow) {
            hasGallery = false;
            this.slide.close();
        }
    }

    componentWillUnmount() {
        this.slide.destroy();
    }

    handleImages = images => {
        const arr = images.map(item => ({
            src: item.url,
            w: item.width,
            h: item.height,
        }));

        return arr;
    };

    render() {
        const { galleryCurrent } = this.state;
        const { content, handleGalleryClose } = this.props;

        return ReactDOM.createPortal(
            <div>
                <div id="slide" className="pswp" tabIndex="-1" role="dialog" aria-hidden="true" ref={this.swiper}>
                    <div className="pswp__bg" />
                    <div className="pswp__scroll-wrap">
                        <div className="pswp__container">
                            <div className="pswp__item" />
                            <div className="pswp__item" />
                            <div className="pswp__item" />
                        </div>
                        <div className="pswp__ui pswp__ui--hidden" style={{ display: 'none' }}>
                            <div className="pswp__top-bar">
                                <div className="pswp__counter" />
                                <button className="pswp__button pswp__button--close" title="Close (Esc)" />
                                <button className="pswp__button pswp__button--share" title="Share" />
                                <button className="pswp__button pswp__button--fs" title="Toggle fullscreen" />
                                <button className="pswp__button pswp__button--zoom" title="Zoom in/out" />
                                <div className="pswp__preloader">
                                    <div className="pswp__preloader__icn">
                                        <div className="pswp__preloader__cut">
                                            <div className="pswp__preloader__donut" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                                <div className="pswp__share-tooltip" />
                            </div>
                            <button className="pswp__button pswp__button--arrow--left" title="Previous (arrow left)" />
                            <button className="pswp__button pswp__button--arrow--right" title="Next (arrow right)" />
                            <div className="pswp__caption">
                                <div className="pswp__caption__center" />
                            </div>
                        </div>
                    </div>
                    <div className={styles.close} onClick={handleGalleryClose} />
                    <div className={styles.num}>
                        <span className={styles.current}>{galleryCurrent + 1}</span>
                        <span className={styles.total}>/{content.length}</span>
                    </div>
                </div>
            </div>,
            document.body,
        );
    }
}

export default errorBoundary(Pic);
